import { redirectTo } from "./handle401Error";
export const baseUrl = import.meta.env.VITE_BASE_URL;

const getHeaders = (token_lang, isJson = true) => {
    const headers = {
        'Authorization': `Bearer ${token_lang.accessToken}`,
        'Accept-Language': token_lang.language || 'de',
    };
    if (isJson) {
        headers['Content-Type'] = 'application/json';
        headers['Accept'] = 'application/json';
    }
    return headers;
};

export const fetchApi = async (url, method = 'GET', token_lang = {}, body = null, isJson = true, isParsed=false, isImage = false) => {
    if (!token_lang.accessToken) return;

    const options = {
        method,
        headers: getHeaders(token_lang, isJson),
        mode: 'cors',
    };
    if (body) {
        options.body = isJson ? JSON.stringify(body) : body;
    }

    try {
        const response = await fetch(`${baseUrl}/${url}`, options);
        if (response.status === 401) {
            redirectTo();
            return
        };

        if (isImage) {
            const responseData = await response.json();
            return { status: response.status, data: responseData };
        }

        if (isParsed) {
            return response;
        } else {
            const data = await (isJson ? response.json() : response);
            return { status: response.status, data };
        }
    } catch (err) {
        throw err;
    }
};

//this api is for 22 countries that have geodata 
export const fetchproximityCountry = async (
    url,
    method = 'GET',
    token_lang = {}
) => {
    if (!token_lang.accessToken) return;

    const options = {
        method,
        headers: {
            'Authorization': `Bearer ${token_lang.accessToken}`,
            'Accept-Language': token_lang.language || 'de',
            'isProximity': true
        },
        mode: 'cors',
    };
    try {
        const response = await fetch(`${baseUrl}/${url}`, options);
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        throw err;
    }
}
